window.$ = require('jquery');
window.jQuery = window.$;
require("@fancyapps/fancybox");
window.WOW = require('../../node_modules/wowjs/dist/wow.min');
window.$.fancybox.defaults.loop = true;
window.slick = require('../../node_modules/slick-carousel/slick/slick.min.js');

import {Dom} from './Dom.js';

class Main {

	constructor() {


		Dom.init();

		$(function () {
			setTimeout(() => {
				$('.container').addClass('on');
			}, 200);
			var winWidth = Dom.win.width();
			var contentWidth = $('.news-body').width();
			var targetWidth = 0;
			if (winWidth > contentWidth) {
				targetWidth = contentWidth;
			} else {
				targetWidth = winWidth;
			}
			$('.wp-content>table').each(function () {
				var t = $(this);
				if (t.width() > targetWidth) {
					t.wrap('<div class="table-overflow">');
				}

			});
			$('.wp-content table td strong').parent().addClass('wp-content-table-header');

			$('.mw_wp_form_confirm .form__input').each(function () {
				var i = $(this);
				if (i.text().indexOf('選択してください') !== -1) {
					i.remove();
				}
			});


		});
		window.wow = new WOW.WOW({
			live: false,
			offset: -50
		}).init();


		//ページ内スクロール
		$("a[href^='#']").click(function (e) {
			e.preventDefault();
			var href = $(this).attr("href");
			var target = $(href == "#" || href == "" ? 'html' : href);
			var position = target.offset().top;
			// if (Dom.ua.Mobile) {
			//      position -= ($('.header-sp').height() * 0.8);
			// }
			position -= $('.header').height();
			$('body,html').stop().animate({scrollTop: position}, 1000);
		});

		$('[data-role=sp-nav-header]').on('click', (e) => {
			e.preventDefault();
			var $target = $(e.currentTarget);
			if ($target.hasClass('on')) {
				$target.removeClass('on')
				$target.next().slideUp(300);
			} else {
				$target.addClass('on')
				$target.next().slideDown(300);
			}
		});


		$('[data-role=teaNavScrollBtn]').on('click', (e) => {
			e.preventDefault();
			var btn = $(e.currentTarget)
			var target = $('#teaNavScroll');
			if (btn.hasClass('on')) {
				target.animate({scrollLeft: 0}, 400);
			} else {
				target.animate({scrollLeft: 300}, 400);
			}
		});
		$('#teaNavScroll').on('scroll', (e) => {
			var target = $('#teaNavScroll');
			var btn = $('[data-role=teaNavScrollBtn]');
			var left = target.scrollLeft();

			if (left > 150) {
				btn.addClass('on');
			} else {
				btn.removeClass('on');
			}
		});


		//
		$('#menuBtn').on('touchstart', () => {
			if ($('#menu').hasClass('on')) {
				$('#menu').slideUp(300, () => {
				}).removeClass('on');
				$('#menuBtn').removeClass('on');
			} else {
				$('#menu').slideDown(300, () => {
				}).addClass('on');
				$('#menuBtn').addClass('on');
			}
		});

		$('[data-close]').click((e) => {
			$('#menu').slideUp(300, () => {
			}).removeClass('on');
			$('#menuBtn').removeClass('on');
		});

		// $('[data-role=popupclose]').click(()=>{
		//     $.fancybox.close(); 
		// });

		$('[data-href]').click((e) => {
			let $target = $(e.currentTarget); 
			let href = $target.attr('data-href');
			if($target.attr('target') && $target.attr('target')=='_blank'){
				window.open(href);				
			}else{
				location.href = href;
			}
			e.stopPropagation();
			e.preventDefault();
		});

		
		if(typeof IS_FRONT_PAGE != 'undefined'){
			$('.container').addClass('on');
		}

		window.addEventListener('load', () => {

			
			
			$('.mv [data-src]').each(function(){
				let tar = $(this); 
				tar.attr('src',tar.attr('data-src'));
			});


			$('[data-role=slide-top]').slick({
				autoplay: true,
				dots: true,
				fade: true,
				speed: 1000,
				autoplaySpeed: 5000,
				easing: 'easeOutElastic',
				arrows: true,
				infinite: true,
				prevArrow: '<img src="/wp-content/themes/elbee/img/top/pc/slide-arr-l.png" class="mv__arr mv__arr--l">',
				nextArrow: '<img src="/wp-content/themes/elbee/img/top/pc/slide-arr-r.png" class="mv__arr mv__arr--r">',
				responsive: [
					{
						breakpoint: 750,
						settings: {
							prevArrow: '<img src="/wp-content/themes/elbee/img/top/sp/slide-arr-l.png" class="mv__arr mv__arr--l">',
							nextArrow: '<img src="/wp-content/themes/elbee/img/top/sp/slide-arr-r.png" class="mv__arr mv__arr--r">',
						}
					}
				]
			}).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
				let current = $('.slick-current');
				var next;
				if (nextSlide == 0) {
					next = current.parent().find('.slick-slide:first-child');
				} else {
					next = current.next();
				}
				next.find('.mv__product').addClass('off');
				setTimeout(() => {
					next.find('.mv__product').removeClass('off');
				}, 700);
			});


			$('[data-role=slide-top-product]').slick({
				draggable: true,
				swipe: true,
				centerMode: true,
				dots: false,
				centerPadding: '0px',
				// width: 400,
				autoplay: true,
				speed: 1000,
				autoplaySpeed: 3000,
				easing: 'easeOutElastic',
				arrows: true,
				slidesToShow: 4,
				slidesToScroll: 1,
				infinite: true,
				responsive: [
					{
						breakpoint: 750,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
							arrows: false,
							dots: true,
						}
					}
				]
			});

			setTimeout(() => {
				$('.mv').addClass('on');
			}, 300);
			setTimeout(() => {
				$('.mv__product').removeClass('off');
			}, 1000);
			setTimeout(() => {
				$('.mv__btn').removeClass('off');
			}, 1300);
			setTimeout(() => {
				$('.header').addClass('on');
				$('.new-products').addClass('on');
			}, 1600);
			
			
			

			$('.product-list__item').css('opacity', 1);
			
		});

	}

}

new Main();
